
import { transports } from 'winston'
import { merge } from 'lodash'
import axios, { AxiosResponse } from 'axios'

export class DatadogTransport extends transports.Http {
	private _usr: { id?: string; clerkId?: string } | undefined = undefined

	constructor(datadogToken: string = '', serviceName: string) {
		super({
			host: 'http-intake.logs.datadoghq.com',
			path: `/api/v2/logs?dd-api-key=${datadogToken}&ddsource=web&service=${encodeURIComponent(serviceName)}`,
			ssl: true,
			silent: !datadogToken?.length
		})
	}

	setUserId(id?: string | number, clerkId?: string | number) {
		if (id || clerkId) {
			this._usr = merge({}, this._usr || {}, { id: id?.toString(), clerkId: clerkId?.toString() })
		}
	}


	get name() {
		return 'datadog'
	}


	set name(_value: string) {}


	log(info: any, callback: () => void) {
		try {
			super.log?.(
				{
					usr: this._usr,
					...info
				},
				callback
			)
		} catch (_err) {
			// Do nothing
		}
	}

	_doRequest = (options: Record<string, unknown>, callback: (err?: Error | null, res?: AxiosResponse) => void) => {
		const self = this as any
		return axios.post(`http${self.ssl ? 's' : ''}://${self.host}${self.port ? `:${self.port}` : ''}${self.path}`, options).then(
			(response) => callback(null, response),
			(error) => callback(error)
		)
	}
}
